import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { UserProfileQueriesConfig } from './userProfile.queries';
export const UserProfileApiClient = createApiClient(UserProfileQueriesConfig);
//# sourceMappingURL=userProfile.api-client.js.map